<template>
  <section class="relative">
    <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
      <BrandWave
:height="150"
flip
variant="trio"
/>
    </div>
    <div
        class="relative bg-cover dp-contentblock block-calltoaction py-largest dp-fsimg noprint"
        style="background-image: url(/images/backgrounds/BQ4C1368-1.jpg);"
    >
      <span class="brand-overlay is-duo is-reversed is-vertical"/>
      <div class="container py-32 relative z-10 max-w-[960px] mx-auto space-y-8 flex flex-col justify-center">
        <h2 class="my-none text-center text-white! js-fade-in is-added is-visible">
          Highlights
        </h2>
        <!-- Mobile: carousel; sm+: flex grid -->
        <UCarousel
            v-if="!isSm"
            v-slot="{ item }"
            :items="highlights"
            class="text-white"
            dots
        >
          <HexagonImage
              :href="item.href"
              :img-src="item.imgSrc"
              :title="item.title"
              additional-class="w-3/4 mx-auto"
          />
        </UCarousel>

        <div
            v-else
            class="flex flex-wrap justify-center gap-x-8 gap-y-10 text-white"
        >
          <HexagonImage
              v-for="(item, i) in highlights"
              :key="i"
              :href="item.href"
              :img-src="item.imgSrc"
              :title="item.title"
              additional-class="w-1/4"
          />
        </div>
      </div>
    </div>
    <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
      <BrandWave
:height="150"
variant="trio"
/>
    </div>
  </section>
</template>

<script lang="ts" setup>
import {useBreakpoints, breakpointsTailwind} from '@vueuse/core';

const breakpoints = useBreakpoints(breakpointsTailwind, {
    ssrWidth: 397,
});
const isSm = breakpoints.greaterOrEqual('sm');

const highlights = [
    {href: '/c/themenspiele/1', imgSrc: '1184944-1800_2.jpg', title: 'Themenspiele'},
    {href: '/c/serie-4.0-metall/86', imgSrc: 'BQ4C5242.jpg', title: 'Serie 4.0 Metall'},
    {href: '/c/klettern-und-motorik/20', imgSrc: 'BQ4C3666.jpg', title: 'Klettern & Motorik'},
    {href: '/c/sand-und-wasser/14', imgSrc: '1186668-1800_9.jpg', title: 'Sand & Wasser'},
    {href: '/c/multisportgeraete/28', imgSrc: 'BQ4C2940.jpg', title: 'Multisportgeräte'},
];
</script>

<style scoped>

</style>
